'use client';

import { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import SectionNavbar from './component/SectionNavbar';
import SectionHero from './component/SectionHero';
import SectionDescription from './component/SectionDescription';
import SectionBenefits from './component/SectionBenefits';
import SectionCommunity from './component/SectionCommunity';
import SectionHowItWorks from './component/SectionHowItWorks';
import SectionContact from './component/SectionContact';
import SectionTopAgent from './component/SectionTopAgent';
import SectionFaq from './component/SectionFaq';
import SectionFooter from './component/SectionFooter';
import SectionPaket from './component/SectionPaket';
import JsonLd from '../JsonLd';

const HomePage = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      offset: 100
    });
  }, []);

  return (
    <div className="bg-white w-full flex flex-col">
      <JsonLd />
      <SectionNavbar />
      <main>
        <SectionHero />
        <SectionDescription />
        <SectionBenefits />
        <SectionCommunity />
        <SectionPaket />
        <SectionTopAgent />
        <SectionHowItWorks />
        <SectionContact />
        <SectionFaq />
      </main>
      <SectionFooter />
    </div>
  );
}
export default HomePage
